import script from "./process.vue?vue&type=script&setup=true&lang=js"
export * from "./process.vue?vue&type=script&setup=true&lang=js"

import "./process.vue?vue&type=style&index=0&id=7625e7a4&scoped=true&lang=css"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7625e7a4"]])

export default __exports__